import { EventBusService } from './../../../services/event-bus-service';
import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BlogService } from '../../../services/blog.service';
import { Blog } from '../../../models/blog';
import { Pagination } from '../../../models/paging';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import constants from '../../../utility/constants';
import messages from '../../../utility/messages';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.css'],
})
export class BlogListComponent implements OnInit, OnDestroy {
  blogData: Array<Blog> = [];
  searchControl = new FormControl();
  searchTerm: string = '';
  pageNumber = 1;
  pageSize = constants.admin.adminPageSize;
  sortBy = '';
  sortOrder = '';
  isPaginated = true;
  onlyActive = false;
  classToggled = false;
  totalBlog: number;
  searchMaxLength = constants.common.validations.searchMaxLength;
  reset: boolean = false;
  //modals
  modalRef: BsModalRef;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private blogService: BlogService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private eventBusService: EventBusService
  ) {}

  ngOnInit(): void {
    this.getAllBlog();
    this.searchBlog();
  }

  resetSearch() {
    this.searchControl.reset();
  }

  private searchBlog() {
    this.searchControl.valueChanges
      .pipe(debounceTime(1100))
      .subscribe((value) => {
        this.searchTerm = value;
        this.pageNumber = 1;
        this.getAllBlog();
      });
  }

  getAllBlog() {
    if (this.searchTerm == null) {
      this.searchTerm = '';
    }
    let model: Pagination = {
      searchTerm: this.searchTerm,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
      isPaginated: this.isPaginated,
      onlyActive: this.onlyActive,
    };

    const req = this.blogService.getBlogs(model).subscribe((response) => {
      this.blogData = response.data;
      this.totalBlog = response.totalCount;
      this.eventBusService.setter(this.totalBlog);
    });
    this.subscriptions.push(req);
  }

  blogName: string;
  blogId: number;

  openModal(template: TemplateRef<any>, blogData: any) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class: 'custom-popup delete-modal modal-dialog modal-dialog-centered',
        }
      )
    );
    this.blogName = blogData.draftTitle || blogData.title;
    this.blogId = blogData.id;
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
      this.blogName = null;
      this.blogId = null;
    }
  }

  onDelete(id: number) {
    const req = this.blogService.deleteBlog(id).subscribe(
      () => {
        this.toastr.success(
          messages.addBlog.deleted,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.reset = true;
        this.pageNumber = 1;
        this.closeModal();
        this.getAllBlog();
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.closeModal();
      }
    );
    this.subscriptions.push(req);
  }
  onPageChange(paging: number) {
    this.pageNumber = paging;
    this.getAllBlog();
  }
  displayedColumns: string[] = [
    'draftTitle',
    'createdOn',
    'blogName',
    'actions',
  ];

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
